import { render, staticRenderFns } from "./bindRuleList.vue?vue&type=template&id=e0ab0cb8&scoped=true"
import script from "./bindRuleList.vue?vue&type=script&lang=js"
export * from "./bindRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ab0cb8",
  null
  
)

export default component.exports